import { useEffect } from "react";
import { PageHeader } from "@/components/ui/page-header";
import { auth } from "../api/firebaseApi";

export const PricingPage = () => {
  useEffect(() => {
    // Load Stripe Pricing Table script
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="h-full w-full overflow-y-auto bg-surface">
      <div className="mx-auto flex w-full max-w-190 flex-col gap-8 px-12 pt-10 pb-24">
        <PageHeader
          title="Plans"
          description="Choose a plan that's right for you."
        />
        <div className="w-full rounded-xl bg-elevated p-4 ring-1 ring-line-2">
          <stripe-pricing-table
            pricing-table-id={
              import.meta.env.REACT_APP_STRIPE_PRICING_TABLE_ID || ""
            }
            publishable-key={
              import.meta.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ""
            }
            customer-email={auth?.currentUser?.email}
            client-reference-id={auth?.currentUser?.uid}
          />
        </div>
      </div>
    </div>
  );
};
